(ns ycweb.app.website.dlp.widgets.selectedproducts
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [util.string :as str]))

(rum/defc selected-products < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:selected-products/keys
         [title on-page-link-id heading-type show-content?
          use-date-range? products spacer spacersize
          columns mobile? rank include-ids]} properties

        products-idx (u/index-by :product/id products)

        products-list
         (cond
          (= rank "random")
          (shuffle products)

          (= rank "nosort")
          (->>
            (str/split include-ids #",\s*")
            (map #(get products-idx %))
            (remove nil?))

          :else
          products)]

    (when show-content?
      [:<>
       [:div.yc-section
        {:id (when on-page-link-id on-page-link-id)}
        (when (u/presence title)
          (headings/heading title
            {:type (keyword (str "h" heading-type))
             :size :default
             :dangerouslySetInnerHTML? true}))

        (when-not (empty? products-list)
          (cond
            (= columns 6)
            [:div
             {:class (u/bem :flex-grid-group [:align-left])}
             (map
               (fn [product]
                 [:div
                  {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
                  (cards/product-card-default app-atom product {:small? true})])
               products-list)]

            (and mobile? (= columns 3))
            [:div
             {:class (u/bem :flex-grid-group [:small :align-left])}
             (map
               (fn [product]
                 [:div
                  {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-2])}
                  (cards/product-card-default app-atom product {:small? true})])
               products-list)]

            :else
            [:div
             {:class (u/bem :flex-grid-group [:small :align-left])}
             (map
               (fn [product]
                 [:div
                  {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 (keyword (str "l-1-" columns))])}
                  (cards/product-card-default app-atom product {:small? true})])
               products-list)]))]

       (when (and spacer use-date-range?)
         [:div
          {:class (u/bem :dlp-spacer [(if (= spacersize "medium") :medium :standard)])}])])))
